import React from "react";

import TrimetModeIcon from "../trimet-mode-icon";

import ModeIconRenderer from "./mode-icon-renderer";

export default {
  title: "Icons/TrimetModeIcon",
  component: TrimetModeIcon
};

export const TrimetModeIconExamples = () => (
  <ModeIconRenderer component={TrimetModeIcon} />
);
